import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { setPageTitle } from 'actions/header';
import { clearFormTemplate, getFormTemplate } from 'actions/templates';
import Redirect from 'components/Redirect/Redirect';
import FormTemplate from 'containers/Forms/FormTemplate';
import PreviewFormTemplate from 'containers/FormTemplate/Display/PreviewFormTemplate';
import Modal from 'containers/Modals/Modal';
import Moment from 'moment';
import React, { Component } from 'react';
import { translate } from '@haldor/ui';
import { connect } from 'react-redux';
import { Spinner } from 'UI';
import { Block, Icon, Button } from '@haldor/ui';

var SingleFormTemplatePage = /*#__PURE__*/function (_Component) {
  _inherits(SingleFormTemplatePage, _Component);

  var _super = _createSuper(SingleFormTemplatePage);

  /* Class setup */
  function SingleFormTemplatePage(props) {
    var _this;

    _classCallCheck(this, SingleFormTemplatePage);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      _this.props.getFormTemplate(_this.props.match.params.id).then(function () {
        _this.props.setPageTitle(_this.props.template.title);

        _this.setState({
          loading: false
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "componentWillUnmount", function () {
      _this.props.clearFormTemplate();
    });

    _defineProperty(_assertThisInitialized(_this), "toggleModal", function (reload) {
      _this.setState({
        modal: !_this.state.modal
      });

      if (reload) {
        _this.props.setPageTitle(_this.props.template.title);
      }
    });

    _this.state = {
      loading: true,
      modal: false
    };
    return _this;
  }
  /* Helpers */


  _createClass(SingleFormTemplatePage, [{
    key: "isIframe",
    value: function isIframe() {
      try {
        return window.self !== window.top;
      } catch (e) {
        return true;
      }
    }
    /* Lifecycle methods */

  }, {
    key: "render",
    value:
    /* Render methods */
    function render() {
      var _this2 = this;

      if (!this.props.services.forms) {
        return /*#__PURE__*/React.createElement(Redirect, {
          to: "/"
        });
      }

      if (this.state.loading) {
        return /*#__PURE__*/React.createElement(Spinner, {
          center: true
        });
      }

      var _this$props = this.props,
          template = _this$props.template,
          translate = _this$props.translate;
      return /*#__PURE__*/React.createElement("div", {
        className: "single-task"
      }, /*#__PURE__*/React.createElement(Modal, {
        isOpen: this.state.modal,
        onClose: function onClose() {
          return _this2.toggleModal(false);
        },
        title: translate('form-template')
      }, /*#__PURE__*/React.createElement(FormTemplate, {
        initialValues: template,
        onAbort: this.toggleModal
      })), /*#__PURE__*/React.createElement("div", {
        className: "single-section form left-side",
        style: {
          paddingTop: 0
        }
      }, /*#__PURE__*/React.createElement(Block, null, /*#__PURE__*/React.createElement("span", {
        className: "title"
      }, translate('preview')), /*#__PURE__*/React.createElement(PreviewFormTemplate, {
        fields: template.fields
      }))), template.instances == 0 ? /*#__PURE__*/React.createElement("div", {
        className: "single-actions right-side"
      }, /*#__PURE__*/React.createElement("div", {
        className: "action-section"
      }, /*#__PURE__*/React.createElement("h3", null, translate('tools')), /*#__PURE__*/React.createElement(Button, {
        type: "secondary",
        onClick: this.toggleModal
      }, /*#__PURE__*/React.createElement(Icon, {
        name: "Pen_Small"
      }), translate('Edit')))) : null, /*#__PURE__*/React.createElement("div", {
        className: "clearfix"
      }));
    }
  }]);

  return SingleFormTemplatePage;
}(Component);

function mapStateToProps(state) {
  return {
    services: state.Services.availableServices,
    translate: translate(state.Languages.translations),
    template: state.Templates.formTemplate
  };
}

export default connect(mapStateToProps, {
  getFormTemplate: getFormTemplate,
  setPageTitle: setPageTitle,
  clearFormTemplate: clearFormTemplate
})(SingleFormTemplatePage);